export default __webpack_public_path__ + "static/media/timer_l3.796025cd.png";